import React from 'react';
import SVGLoader from './SVGLoader';

export default ({ viewboxWidth = 13, viewboxHeight = 15, ...rest }) => (
  <SVGLoader
    viewboxHeight={viewboxHeight}
    viewboxWidth={viewboxWidth}
    {...rest}
  >
    <path
      d="M11.87 2.25h-1.555a.14.14 0 0 1-.1-.043.15.15 0 0 1-.041-.103v-1.02a.6.6 0 0 0-.166-.413.557.557 0 0 0-.799 0 .6.6 0 0 0-.166.412v2.771a.45.45 0 0 1-.124.31.417.417 0 0 1-.6 0 .45.45 0 0 1-.123-.31V2.542a.3.3 0 0 0-.083-.207.28.28 0 0 0-.2-.085H4.38a.14.14 0 0 1-.1-.043.15.15 0 0 1-.04-.103v-1.02A.6.6 0 0 0 4.073.67a.556.556 0 0 0-.8 0 .6.6 0 0 0-.165.412v2.771a.45.45 0 0 1-.124.31.417.417 0 0 1-.6 0 .45.45 0 0 1-.124-.31V2.542a.3.3 0 0 0-.083-.207.28.28 0 0 0-.2-.085H1.13c-.3 0-.587.123-.799.342A1.2 1.2 0 0 0 0 3.417v9.916c0 .31.12.607.331.825.212.22.5.342.8.342H11.87c.3 0 .587-.123.799-.342.212-.218.331-.515.331-.825V3.417c0-.31-.12-.606-.331-.825a1.1 1.1 0 0 0-.8-.342m-.283 11.083H1.413a.28.28 0 0 1-.2-.085.3.3 0 0 1-.083-.206v-7c0-.078.03-.152.083-.207a.28.28 0 0 1 .2-.085h10.174c.075 0 .147.03.2.085a.3.3 0 0 1 .083.207v7c0 .077-.03.151-.083.206a.28.28 0 0 1-.2.085"
      fill="currentFill"
    />
  </SVGLoader>
);
